import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'
import Card from '../../components/Card'
import Grid from '../../components/Grid'
import OutlineButton from '../../components/OutlineButton'
import Text from '../../components/Text'
import patient from '../../stores/patient'
import MedicationForm from './MedicationForm'
import request from "../../utils/request";

const RemoveButton = styled.button`
  background: transparent;
  color: var(--gray);
  cursor: pointer;
  width: 100%;
  font-size: 0.9rem;
  &:hover {
    color: var(--red);
  }
`

@observer
export default class MedicationList extends Component {
  state = {
    allMonitors: [],
    apiAssignedMonitors: []
  };

  componentDidMount() {
    request('/api/monitor/fetch')
      .then(response => {
        if (response.success) {
          this.setState({
            allMonitors: response.data.allMonitors,
            apiAssignedMonitors: response.data.assignedMonitors
          });
        }
      })
      .catch(error => console.error(error));
  }

  render() {
    const { onAddMedication } = this.props
    const { allMonitors, apiAssignedMonitors } = this.state;

    // Calculate monitors assigned to THIS patient
    const currentPatientMonitors = patient.fields.medications.flatMap(m =>
      (m.monitors || []).map(mon => mon.monitorID)
    );

    // Combine with API's assigned monitors
    const assignedMonitors = [...apiAssignedMonitors, ...currentPatientMonitors];

    return (
      <Grid>
        <Grid.FullCell>
          <OutlineButton
            icon="fas fa-eye-dropper"
            str="titles.addNewMedication"
            onClick={onAddMedication}
          />
        </Grid.FullCell>
        {patient.fields.medications.map((medication, index) => (
          <Grid.FullCell key={index}>
            <Card>
              <Card.Pad>
                <MedicationForm
                  prescription={medication.prescription}
                  eye={medication.eye}
                  frequency={medication.frequency}
                  monitors={medication.monitors || []}
                  onChange={event => patient.setMedicationField(index, event)}
                  medicationIndex={index}
                  prescriptionStartDate={medication.prescriptionStartDate}
                  prescriptionEndDate={medication.prescriptionEndDate}
                  allMonitors={allMonitors}
                  assignedMonitors={assignedMonitors}
                />
                <RemoveButton onClick={() => patient.removeMedication(index)}>
                  <Text str="titles.remove" />
                </RemoveButton>
              </Card.Pad>
            </Card>
          </Grid.FullCell>
        ))}
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/EditPatient/MedicationList.js